/* eslint-disable class-methods-use-this */
import { AnalyticsData, AnalyticsStrategy } from '@kueski-analytics/types';
import * as braze from '@braze/web-sdk';

export class BrazeProvider implements AnalyticsStrategy {
  sendEvent(eventName: string, data?: AnalyticsData) {
    if (eventName === 'purchase_event') {
      if (data !== undefined) {
        braze.changeUser(data.customer_id as string);
        braze.logPurchase(data.product as string, data.price as number, 'MXN', data.quantity as number, data);
        braze.requestImmediateDataFlush();
      }
    } else {
      braze.logCustomEvent(eventName, data);
    }
  }
}
